import { BarnIcon } from './BarnIcon';

/**
 * author: SarinManS
 * id 678BDE48-30CE-4897-BA06-9991001FA842
 * name barn
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/barn.svg
 * tags
 * - Agriculture 
 */
export const FarmIcon = BarnIcon;
export default FarmIcon